import React, { useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'

export interface UpdateSystemEmailTypeModalProps {
  show: boolean
  onConfirm: (newName?: string) => void
  onCancel: () => void
  emailTypeName: string
}
export const UpdateSystemEmailTypeModal: React.FC<UpdateSystemEmailTypeModalProps> = ({ show, onConfirm, onCancel, emailTypeName }) => {
  const [newEmailTypeName, setNewEmailTypeName] = useState<string>(emailTypeName)

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Update System Email Type</h4>
        </Col>
      </Row>
      <Row className=''>
        <Col className='p-0'>
          <div className='paragraph-medium mb-3'>System email types cannot be changed. Would you like to create a new email type?</div>
          <div className='lead-small'>New Email Type Name</div>
          <Form.Control type='text' value={newEmailTypeName} onChange={(e) => setNewEmailTypeName(e.currentTarget.value)} placeholder='Enter a name…' />
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={() => onConfirm(newEmailTypeName)}
      footerPrimaryActionTitle='Save as New Email Type'
      footerPrimaryActionButtonVariant='primary'
      footerPrimaryActionDisabled={!newEmailTypeName}
    />
  )
}
